import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const NetworkONTBlockRoutes = defineRoute({
    record: {
        route: {
            path: "/network-ont-block",
            component: () => loadView(import("./NetworkONTBlockTable.vue")),
        },
    },
    create: {
        route: {
            path: "/network-ont-block/create",
            component: () => loadView(import("./NetworkONTBlockCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/network-ont-block/update/:id",
            component: () => loadView(import("./NetworkONTBlockUpdate.vue")),
        },
        build(id: string) {
            return `/network-ont-block/update/${id}`;
        },
    },
});
